import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';

import { useLocation } from 'react-router-dom';

import { getStudentAuditLogs } from '../../../../../services/apiService';

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
  headerComponentParams: {
    menuIcon: 'fa-bars',
    template: `<div class="ag-cell-label-container" role="presentation">  
                            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>  
                            <div ref="eLabel" class="ag-header-cell-label" role="presentation">    
                                <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>    
                                <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>    
                                <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>    
                                <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>    
                                <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>    
                                <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>  
                            </div>
                        </div>`,
  },
};

const pageSize = 10;

export default function AuditLogs() {
  const location = useLocation();

  const userParams = location.state.userParams;

  const courseType = userParams?.UserSubscriptions_courseType;
  const userId = userParams?.id;

  const columnDefs = [
    {
      field: 'eventTime',
      headerName: 'Date',
      valueFormatter: (params) => {
        return params?.value
          ? moment(params?.value).format('DD MMM YYYY')
          : '-';
      },
    },
    { field: 'eventType' },
    {
      field: 'data.reason',
      headerName: 'Feedback',
      autoHeight: true,
      width: 300,
      cellRenderer: (params) => {
        return (
          <div
            className='flex items-center break-words w-full'
            style={{ whiteSpace: 'normal' }}
          >
            {params.value}
          </div>
        );
      },
    },
  ];

  const [rowData, setRowData] = useState(null);

  const fetchData = async () => {
    try {
      if (courseType && userId) {
        const response = await getStudentAuditLogs(courseType, userId);
        setRowData(response);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };

  useEffect(() => {
    fetchData();
  }, [courseType, userId]);

  return (
    <div>
      <div className='ag-theme-alpine h-96  w-full'>
        <AgGridReact
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowData={rowData}
          rowSelection='multiple'
          suppressRowClickSelection='true'
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          pagination={true}
          paginationPageSize={pageSize}
          // rowHeight={300}
        />
      </div>
    </div>
  );
}
